import React, {Component} from 'react';
import utils from "../../common/utils";
import SimpleDataTable from "../common/SimpleDataTable";
import {Translation} from "react-i18next";

class OrderTransaction extends Component {
  columns = (t) => [
    {
      title: t('exchange.order_transaction.time'),
      width: 80,
      dataIndex: 'created_at',
      key: 'created_at',
      style: {
        paddingLeft: '5px',
      }
    },
    {
      title: t('exchange.order_transaction.amount'),
      width: 100,
      dataIndex: 'quantity',
      key: 'quantity',
      style: {
        paddingLeft: '5px',
      },
      render: (quantity) => !!quantity ? utils.specialFormatJsx(quantity) : 0
    },
    {
      title: t('exchange.order_transaction.price'),
      width: 95,
      dataIndex: 'price',
      key: 'price',
      style: {marginRight: '5px'},
      render: (price, {transaction_type}) => <div
        className={transaction_type === window.c.ORDER_TRADE_TYPE_BUY ? 'buy ellipsis' : 'sell ellipsis'}>
        {utils.formatCurrency(price)}
      </div>
    },
  ];
  
  componentDidMount() {
    this.props.onfetchAllOrderTransactionAction({
      coin: this.props.coin,
      currency: this.props.currency,
    });
  }
  
  onClickTrBuy(event, item) {
    this.props.onClickOrderBookBuy({...item, cumulate: item.quantity})
    this.props.orderClick('Buy');
  }
  
  onClickTrSell(event, item) {
    this.props.onClickOrderBookSell({...item, cumulate: item.quantity});
    this.props.orderClick('Sell');
  }
  
  onClickTr(e, item) {
    if (item.transaction_type === window.c.ORDER_TRADE_TYPE_SELL) {
      this.onClickTrBuy(e, item);
    } else {
      this.onClickTrSell(e, item);
    }
  }
  
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.coin !== this.props.coin || nextProps.currency !== this.props.currency
      || utils.hash(nextProps.orderTransactions) !== utils.hash(this.props.orderTransactions);
  }
  
  render() {
    return (
      <Translation>
        {(t) => <div className="order-transaction-wrap scroll scroll-0">
          <SimpleDataTable scroll={true} columns={this.columns(t)}
                           data={[...this.props.orderTransactions || []]}
                           showTitle={true}
                           onClickTr={(e, item) => this.onClickTr(e, item)} className="full-height scroll scroll-0"/>
        </div>}
      </Translation>
    );
  }
}

export default OrderTransaction;
